import _ from "underscore";
import Backbone from "backbone";
import Chaplin from "chaplin";
import TranscribedFilesPageView from "views/myLibrary/TranscribedFilesPageView";
import PersistentModels from "services/PersistentModels";
import RSVP from "rsvp";

const TranscribedFilesPageController = Chaplin.Controller.extend({
  initialize: function (options) {
    _.extend(this, Backbone.Events);
    if (options) {
      if (options.view) {
        this.view = options.view;
      }
      if (options.model) {
        this.model = options.model;
      }
    }
  },

  getModel: function () {
    return this.model;
  },

  getView: function () {
    return this.view;
  },

  showHomePopup: function () {
    PersistentModels.getInstance().getRouter().showHomePage();
  },

  buildModelAndRenderView: function () {
    return new RSVP.Promise(
      function (resolve, reject) {
        try {
          const viewParams = {};
          this.view = new TranscribedFilesPageView(viewParams);

          this.listenTo(this.view, "showHomePopup", this.showHomePopup);

          this.view.render();
          resolve();
        } catch (error) {
          reject(error);
        }
      }.bind(this)
    );
  },
});

export default TranscribedFilesPageController;
